import React, {useMemo, useState} from "react";
import useIsMounted from "../../../../../../../../hooks/use-is-mounted";
import Api from "../../../../../../../../../core/services/api/api";
import PartAutocomplete from "../../../../../../../../components/text-fields/autocomplete/part-autocomplete";

const UserHomepageControlPanelComponentCreatePart = ({parts, updating, add}) => {
    const [fetchingTags, setFetchingTags] = useState(false);
    const isMounted = useIsMounted();

    const partIds = useMemo(() => parts.map(e => e.id), [parts])
    const disabled = useMemo(() => updating || fetchingTags, [updating, fetchingTags])

    /**
     * Invokes the appropriate controller callback for the adding a new content to a component.
     * @param {any} part
     */
    const addNewPart = async (part) => {
        if (disabled)
            return;
        if (partIds.includes(part.id))
            return; // part already exists.
        const _part = {
            ...part,
            partNo: part.partNo ?? part.partNumber,
            tags: await getPartTags(part.id),
        }
        add(_part);
    }

    /**
     * Fetches the tags associated with the selected part from the server and returns them.
     *
     * @param {number} partId
     * @return {Promise<*[]>}
     */
    const getPartTags = async (partId) => {
        setFetchingTags(true);
        const response = await Api.getTagsOfProduct(partId);
        let res = [];
        if (!isMounted())
            return res;
        if (response?.resultFlag) {
            res = response?.data?.map(e => ({
                ...e,
                iconFileName: !!e.iconFileName
                    ? response?.configuration?.TagIconUrlBaseAddress?.concat(e.iconFileName ?? '')
                    : null,
            }))
        }
        setFetchingTags(false);
        return res;
    }

    return (
        <>
            <PartAutocomplete
                className={'mx-2'}
                clearOnBlur
                disabled={disabled}
                label={"New Product"}
                value={null}
                onChange={(_, value) => value && addNewPart(value)}
                filterOptions={(options) => options.filter(e => !partIds.includes(e.id))}
            />
        </>
    )
}

export default UserHomepageControlPanelComponentCreatePart;
